import React from 'react'
import PropTypes from 'prop-types'
import { Indicator, LocalizedText } from 'labguard-cdk'
import { AcqChainIcon } from 'src/components/common'

const AcqChainNameIndicator = ({ name, ...props }) => (
  <Indicator
    icon={AcqChainIcon}
    separator
    title={name}
    subtitle={<LocalizedText id="WEB_ACQ_CHAIN_NAME" />}
    color="info"
    height="1.875rem"
    {...props}
  />
)

AcqChainNameIndicator.propTypes = {
  name: PropTypes.node,
}

export default React.memo(AcqChainNameIndicator)
